(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-vehicle-results"] && !Shopify.designMode) return;
  try {
    class RRVehicleResults extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.config = JSON.parse(this.querySelector('[data-rr-config]').textContent);
    for (const group of [this.config.categories,this.config.text]) for (const key of Object.keys(group)) group[key]=new DOMParser().parseFromString(group[key],'text/html').body.textContent;
    for (const [name, selector] of Object.entries({form:'form',sidebar:'sidebar',dialog:'dialog',openButton:'open',category:'category',brand:'brand',sort:'sort',grid:'grid',flow:'flow',status:'status',more:'more',sentinel:'sentinel',indexStatus:'index-status',retry:'retry',count:'count'})) this[name] = this.querySelector(`[data-rr-${selector}]`);
    this.params = new URLSearchParams(window.location.search);
    this.selection = this.readSelection();
    this.loadedIds = new Set(Array.from(this.grid.querySelectorAll('[data-rr-product-id]'), card => card.dataset.rrProductId));
    this.nextUrl = this.nativePageUrl(this.flow.dataset.nextUrl);
    this.generation = 0;
    this.cardCache = new Map();
    this.cacheCards(Array.from(this.grid.querySelectorAll('[data-rr-product-id]')));
    this.titleVehicle();
    this.bindControls();
    this.initVehicleSelector();
    this.more.setAttribute('role','button');
    this.more.addEventListener('click', event => {event.preventDefault();this.loadMore();});
    this.more.addEventListener('keydown', event => {if(event.key===' '){event.preventDefault();this.loadMore();}});
    if ('IntersectionObserver' in window) this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting) && !this.flowFailed) this.loadMore();
    }, {rootMargin:'600px 0px'});
    this.updateFlow();
    if (this.hasSelection()) this.grid.hidden = true;
    this.loadIndex();
  }

  disconnectedCallback() {
    this.mobileQuery?.removeEventListener('change',this.onBreakpoint);
    this.finderObserver?.disconnect();
    this.removeEventListener('rr:layout-test-change',this.onBreakpoint);
    this.vehicleDialog?.close();
    if(this.vehicleWidget&&this.vehiclePlaceholder?.parentNode)this.vehiclePlaceholder.after(this.vehicleWidget);
    this.vehicleSection?.removeAttribute('data-rr-vehicle-collapsed');
    this.emptyCollectionHeader?.removeAttribute('data-rr-vehicle-collapsed');
    this.vehiclePlaceholder?.remove();
    this.observer?.disconnect();
    this.request?.abort();
    this.indexRequest?.abort();
    window.removeEventListener('popstate',this.onPopState);
  }

  readSelection() {
    const p = new URLSearchParams(window.location.search);
    return {category:p.get('rr_category')||'',brand:p.get('rr_brand')||p.get('filter.p.vendor')||'',sort:p.get('sort_by')||''};
  }

  hasSelection() {return Boolean(this.selection.category||this.selection.brand||this.selection.sort);}

  titleVehicle() {
    const words=this.dataset.fitmentTag.split('-esi')[0].split('-');
    const acronyms=new Set(['gt','gti','gtd','wrx','sti','rs','rs3','rs4','rs5','rs6','rs7','rs8','gr','gr86','brz','bmw','amg','srt','srt8','srt4','gts','gt3','gt4','gt500','gt350','gtr','gt-r','vw','v6','v8','v10','v12','vtec','lx','cx','dx','sx','se','si','ss','xl','xlt','st','svt','suv','awd','4wd','z06','z28','zr1','cr-v','crv','hrv','isf','evo','r','z','350z','370z','m2','m3','m4','m5','m6','m8']);
    if (/^\d{4}$/.test(words[0]||'') && /^\d{4}$/.test(words[1]||'')) words.splice(0,2,`${words[0]}–${words[1]}`);
    const vehicle=words.map(w=>acronyms.has(w)?w.toUpperCase():w.charAt(0).toUpperCase()+w.slice(1)).join(' ');
    this.querySelector('[data-rr-title]').textContent=this.config.text.title.replace('__VEHICLE__',vehicle);
    this.querySelector('[data-rr-subtitle]').textContent=this.config.text.subtitle.replace('__VEHICLE__',vehicle);
    this.querySelector('[data-rr-selected-vehicle]').textContent=vehicle;
  }

  initVehicleSelector() {
    this.vehicleOpen=this.querySelector('[data-rr-vehicle-open]');
    this.vehicleDialog=this.querySelector('[data-rr-vehicle-dialog]');
    this.mobileQuery=window.matchMedia('(max-width: 990px)');
    this.onBreakpoint=()=>this.updateMobileLayout();
    this.mobileQuery.addEventListener('change',this.onBreakpoint);
    this.addEventListener('rr:layout-test-change',this.onBreakpoint);
    this.vehicleOpen.addEventListener('click',()=>{
      if(!this.vehicleWidget)return;
      this.vehicleDialog.showModal();
      this.bodyOverflow=document.body.style.overflow;
      document.body.style.overflow='hidden';
      this.vehicleOpen.setAttribute('aria-expanded','true');
      this.vehicleDialog.querySelector('select:not(:disabled)')?.focus();
    });
    this.querySelector('[data-rr-vehicle-close]').addEventListener('click',()=>this.vehicleDialog.close());
    this.vehicleDialog.addEventListener('close',()=>{
      if(this.bodyOverflow!==undefined){document.body.style.overflow=this.bodyOverflow;this.bodyOverflow=undefined;}
      this.vehicleOpen.setAttribute('aria-expanded','false');
      if(this.hasAttribute('data-rr-mobile'))this.vehicleOpen.focus();
    });
    this.vehicleDialog.addEventListener('click',event=>{
      if(event.target!==this.vehicleDialog)return;
      const b=this.vehicleDialog.getBoundingClientRect();
      if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.vehicleDialog.close();
    });
    const scope=this.closest('.collection-wrapper')||this.parentElement;
    const collectionHeader=scope.querySelector('.section--collection-header');
    if(collectionHeader&&!collectionHeader.textContent.trim()&&!collectionHeader.querySelector('img,h1,nav'))this.emptyCollectionHeader=collectionHeader;
    const attach=()=>{
      const finder=scope.querySelector('.easysearch-main-widget');
      const block=finder?.closest('.shopify-app-block');
      if(!block||!finder.querySelector('select'))return false;
      this.vehicleWidget=block;
      this.vehicleSection=block.closest('.shopify-section');
      this.canCollapseVehicleSection=this.vehicleSection?.querySelectorAll('.shopify-app-block').length===1;
      this.vehiclePlaceholder=document.createComment('Vehicle selector desktop position');
      block.before(this.vehiclePlaceholder);
      this.setAttribute('data-rr-vehicle-ready','');
      this.updateMobileLayout();
      return true;
    };
    if(!attach()){
      this.finderObserver=new MutationObserver(()=>{if(attach())this.finderObserver.disconnect();});
      this.finderObserver.observe(scope,{childList:true,subtree:true});
    }
    this.updateMobileLayout();
  }

  updateMobileLayout() {
    const mobile=this.hasAttribute('data-rr-mobile-test')||this.mobileQuery.matches;
    this.toggleAttribute('data-rr-mobile',mobile);
    this.emptyCollectionHeader?.toggleAttribute('data-rr-vehicle-collapsed',mobile);
    if(mobile&&this.dialog.open)this.dialog.close();
    if(!this.vehicleWidget)return;
    if(mobile){
      this.querySelector('[data-rr-vehicle-body]').append(this.vehicleWidget);
      if(this.canCollapseVehicleSection)this.vehicleSection.setAttribute('data-rr-vehicle-collapsed','');
      for(const group of this.form.querySelectorAll('details'))group.open=true;
    }else{
      this.vehicleDialog.close();
      this.vehiclePlaceholder.after(this.vehicleWidget);
      this.vehicleSection?.removeAttribute('data-rr-vehicle-collapsed');
    }
  }

  bindControls() {
    this.form.addEventListener('submit',event=>{
      event.preventDefault();
      if (!this.index) return;
      this.selection={category:this.category.value,brand:this.brand.value,sort:this.sort.value};
      this.dialog.close();
      this.setUrl();
      this.applySelection();
    });
    this.form.addEventListener('change',event=>{
      if (this.dialog.open) {
        if (event.target===this.category) this.updateBrands(this.category.value,this.brand.value);
      } else this.form.requestSubmit();
    });
    this.addEventListener('click',event=>{
      const link=event.target.closest('[data-rr-clear]');
      if (!link) return;
      if (!this.index) return;
      event.preventDefault();
      this.selection={category:'',brand:'',sort:''};
      this.setUrl();
      this.applySelection();
    });
    this.openButton.addEventListener('click',()=>{
      this.querySelector('[data-rr-dialog-body]').append(this.form);
      this.dialog.showModal();
    });
    this.querySelector('[data-rr-close]').addEventListener('click',()=>this.dialog.close());
    this.dialog.addEventListener('close',()=>{
      this.sidebar.append(this.form);
      if (this.index) this.syncControls();
      this.openButton.focus();
    });
    this.dialog.addEventListener('click',event=>{
      if (event.target!==this.dialog) return;
      const b=this.dialog.getBoundingClientRect();
      if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.dialog.close();
    });
    this.retry.addEventListener('click',()=>this.loadIndex());
    this.onPopState=()=>{
      this.selection=this.readSelection();
      if(this.index)this.applySelection();
    };
    window.addEventListener('popstate',this.onPopState);
    for(const link of this.querySelectorAll('[data-rr-clear]')) link.href=this.baseUrl().href;
  }

  preservePreview(url) {
    for (const key of ['preview_theme_id','_fd','pb']) if(this.params.has(key)) url.searchParams.set(key,this.params.get(key));
    return url;
  }

  baseUrl() {return this.preservePreview(new URL(this.dataset.baseUrl,window.location.origin));}

  setUrl() {
    const url=this.baseUrl();
    if(this.selection.category)url.searchParams.set('rr_category',this.selection.category);
    if(this.selection.brand)url.searchParams.set('rr_brand',this.selection.brand);
    if(this.selection.sort)url.searchParams.set('sort_by',this.selection.sort);
    if(url.href!==window.location.href)history.pushState(null,'',url);
  }

  nativePageUrl(value) {
    if(!value)return '';
    const next=new URL(value,window.location.origin);
    if(next.origin!==window.location.origin||!next.searchParams.has('page'))throw new Error('Invalid parts page');
    const url=new URL(window.location.href);
    url.searchParams.set('page',next.searchParams.get('page'));
    return this.preservePreview(url).href;
  }

  async indexPage(page,signal) {
    const url=this.baseUrl();
    url.searchParams.set('view','rr-index');
    url.searchParams.set('page',String(page));
    const response=await fetch(url,{signal});
    if(!response.ok)throw new Error('Index request failed');
    const data=await response.json();
    if(data.tag!==this.dataset.fitmentTag||data.page!==page||!Array.isArray(data.items))throw new Error('Invalid vehicle index');
    return data;
  }

  async loadIndex() {
    this.indexRequest?.abort();
    const controller=this.indexRequest=new AbortController();
    this.dataset.indexState='loading';
    this.indexStatus.textContent=this.config.text.loading_index;
    this.retry.hidden=true;
    try {
      const first=await this.indexPage(1,controller.signal);
      if(first.total>25000)throw new Error('Vehicle index exceeds pagination limit');
      const pages=[first];
      for(let page=2;page<=first.pages;page+=2) {
        const numbers=[page];
        if(page+1<=first.pages)numbers.push(page+1);
        pages.push(...await Promise.all(numbers.map(n=>this.indexPage(n,controller.signal))));
      }
      if(!this.isConnected||controller.signal.aborted)return;
      const index=pages.flatMap(p=>p.items);
      const ids=new Set(index.map(p=>p.id));
      if(index.length!==first.total||ids.size!==first.total||pages.some(p=>p.total!==first.total||p.pages!==first.pages)||index.some(p=>!p.id||!p.handle||!Number.isFinite(p.price)))throw new Error('Incomplete vehicle index');
      this.index=index.map((p,order)=>({...p,order,category:this.config.types[p.type]||'other'}));
      this.dataset.indexCount=String(index.length);
      this.dataset.indexState='ready';
      this.indexStatus.textContent='';
      for(const control of this.form.querySelectorAll('select,button[type="submit"]'))control.disabled=false;
      const validSort=['','price-ascending','price-descending'];
      if(!validSort.includes(this.selection.sort))this.selection.sort='';
      await this.applySelection(true);
    } catch(error) {
      if(error.name==='AbortError'||!this.isConnected)return;
      this.dataset.indexState='error';
      this.indexStatus.textContent=this.config.text.index_error;
      this.retry.hidden=false;
      if(this.hasSelection())this.status.textContent=this.config.text.index_error;
    }
  }

  categoryOptions() {
    const counts=new Map();
    for(const item of this.index)counts.set(item.category,(counts.get(item.category)||0)+1);
    const options=[new Option(this.config.text.all_categories,'')];
    for(const [key,label] of Object.entries(this.config.categories))if(counts.has(key))options.push(new Option(`${label} (${counts.get(key)})`,key));
    if(this.selection.category&&!counts.has(this.selection.category))options.push(new Option(`${this.config.categories[this.selection.category]||this.selection.category} (0)`,this.selection.category));
    this.category.replaceChildren(...options);
    this.category.value=this.selection.category;
  }

  updateBrands(category,selected) {
    const counts=new Map();
    for(const item of this.index)if(!category||item.category===category)counts.set(item.vendor,(counts.get(item.vendor)||0)+1);
    const options=[new Option(this.config.text.all_brands,'')];
    for(const [vendor,count] of [...counts].sort((a,b)=>a[0].localeCompare(b[0])))if(vendor)options.push(new Option(`${vendor} (${count})`,vendor));
    if(selected&&!counts.has(selected))options.push(new Option(`${selected} (0)`,selected));
    this.brand.replaceChildren(...options);
    this.brand.value=selected;
  }

  syncControls() {
    this.categoryOptions();
    this.updateBrands(this.selection.category,this.selection.brand);
    this.sort.value=this.selection.sort;
  }

  async applySelection(initial=false) {
    if(!this.index)return;
    this.generation++;
    this.request?.abort();
    this.loading=false;
    this.flowFailed=false;
    this.observer?.disconnect();
    this.syncControls();
    this.matches=this.index.filter(p=>(!this.selection.category||p.category===this.selection.category)&&(!this.selection.brand||p.vendor===this.selection.brand));
    if(this.selection.sort)this.matches.sort((a,b)=>(this.selection.sort==='price-ascending'?a.price-b.price:b.price-a.price)||a.order-b.order);
    this.dataset.total=String(this.matches.length);
    this.count.textContent=(this.matches.length===1?this.config.text.results_single:this.config.text.results).replace('__COUNT__',String(this.matches.length));
    const cards=Array.from(this.grid.querySelectorAll('[data-rr-product-id]'));
    const prefix=initial&&!this.hasSelection()&&cards.length<=this.matches.length&&cards.every((c,i)=>c.dataset.rrProductId===this.matches[i].id);
    if(prefix) {
      this.cursor=cards.length;
      this.grid.hidden=false;
      this.updateFlow();
      return;
    }
    this.cursor=0;
    this.loadedIds.clear();
    this.grid.replaceChildren();
    this.grid.hidden=false;
    if(!this.matches.length) {
      const empty=document.createElement('div');
      empty.className='rr-vehicle__empty';
      const text=document.createElement('p');text.textContent=this.config.text.no_matches;
      const link=document.createElement('a');link.href=this.baseUrl();link.dataset.rrClear='';link.textContent=this.config.text.return_vehicle;
      empty.append(text,link);this.grid.append(empty);
      this.updateFlow();return;
    }
    this.updateFlow();
    await this.loadMore();
  }

  cacheCards(cards) {
    for(const card of cards)this.cardCache.set(card.dataset.rrProductId,card.cloneNode(true));
    while(this.cardCache.size>216)this.cardCache.delete(this.cardCache.keys().next().value);
  }

  updateFlow() {
    const total=Number(this.dataset.total),loaded=this.loadedIds.size;
    this.dataset.loaded=String(loaded);
    this.flow.hidden=total===0;
    this.flow.dataset.nextUrl=this.index?'':this.nextUrl;
    const hasMore=this.index?this.cursor<this.matches.length:Boolean(this.nextUrl);
    this.status.textContent=(loaded===total?(total===1?this.config.text.all_loaded_single:this.config.text.all_loaded):this.config.text.loaded_parts).replace('__LOADED__',String(loaded)).replace('__TOTAL__',String(total));
    this.more.hidden=!hasMore;
    this.more.href=this.index?this.baseUrl().href:this.nextUrl||this.baseUrl().href;
    this.grid.removeAttribute('aria-busy');
    this.more.removeAttribute('aria-disabled');
    if(hasMore)this.observer?.observe(this.sentinel);
    else this.observer?.disconnect();
  }

  chunks(items) {
    const chunks=[];let chunk=[],length=0;
    for(const item of items) {
      const size=encodeURIComponent(item.handle).length+3;
      if(chunk.length&&(chunk.length===20||length+size>1800)){chunks.push(chunk);chunk=[];length=0;}
      chunk.push(item);length+=size;
    }
    if(chunk.length)chunks.push(chunk);
    return chunks;
  }

  async renderCards(items,signal) {
    const missing=items.filter(item=>!this.cardCache.has(item.id));
    const responses=await Promise.all(this.chunks(missing).map(async chunk=>{
      const url=this.preservePreview(new URL(this.dataset.searchUrl,window.location.origin));
      url.searchParams.set('q',chunk.map(p=>p.handle).join('|'));
      url.searchParams.set('type','product');url.searchParams.set('view','rr-cards');
      const response=await fetch(url,{signal});
      if(!response.ok)throw new Error('Card request failed');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const cards=Array.from(doc.querySelectorAll('[data-rr-cards] > [data-rr-product-id]'));
      if(cards.length!==chunk.length||cards.some((card,i)=>card.dataset.rrProductId!==chunk[i].id))throw new Error('Incomplete product cards');
      return cards;
    }));
    const found=new Map(responses.flat().map(card=>[card.dataset.rrProductId,card]));
    return items.map(item=>found.get(item.id)||this.cardCache.get(item.id).cloneNode(true));
  }

  async loadMore() {
    if(this.loading||!this.isConnected)return;
    if(!this.index&&(this.hasSelection()||!this.nextUrl))return;
    if(this.index&&this.cursor>=this.matches.length)return;
    const generation=this.generation;
    const controller=this.request=new AbortController();
    this.loading=true;this.flowFailed=false;
    this.grid.setAttribute('aria-busy','true');this.more.setAttribute('aria-disabled','true');
    this.status.textContent=this.config.text.loading_parts;
    try {
      let cards;
      if(this.index) {
        const items=this.matches.slice(this.cursor,this.cursor+36);
        cards=await this.renderCards(items,controller.signal);
        if(!this.isConnected||generation!==this.generation||controller.signal.aborted)return;
        this.cursor+=items.length;
      } else {
        const response=await fetch(this.nextUrl,{signal:controller.signal});
        if(!response.ok)throw new Error('Parts request failed');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const result=doc.querySelector('rr-vehicle-results');
        if(!result||result.dataset.fitmentTag!==this.dataset.fitmentTag||result.dataset.total!==this.dataset.total)throw new Error('Invalid vehicle response');
        cards=Array.from(result.querySelectorAll('[data-rr-grid] > [data-rr-product-id]'));
        if(!cards.length)throw new Error('Empty parts response');
        const following=this.nativePageUrl(result.querySelector('[data-rr-flow]').dataset.nextUrl);
        if(following===this.nextUrl)throw new Error('Repeated parts page');
        if(!this.isConnected||generation!==this.generation||controller.signal.aborted)return;
        this.nextUrl=following;
      }
      if(cards.some(card=>this.loadedIds.has(card.dataset.rrProductId)))throw new Error('Repeated product');
      this.cacheCards(cards);
      const fragment=document.createDocumentFragment();
      for(const card of cards){this.loadedIds.add(card.dataset.rrProductId);fragment.append(card);}
      this.grid.append(fragment);
      this.updateFlow();
    } catch(error) {
      if(error.name!=='AbortError'&&this.isConnected&&generation===this.generation){this.flowFailed=true;this.status.textContent=this.config.text.load_error;}
    } finally {
      if(generation===this.generation){this.loading=false;this.grid.removeAttribute('aria-busy');this.more.removeAttribute('aria-disabled');}
    }
  }
}
if(!customElements.get('rr-vehicle-results'))customElements.define('rr-vehicle-results',RRVehicleResults);
  } catch(e) { console.error(e); }
})();

})();
